module.exports = __webpack_public_path__ + "static/media/OurStory-TealCircle.9c4d0f62.svg";